import {List} from 'immutable';
import DefaultNavRenderer from './renderers/DefaultNavRenderer';
import InboxNavRenderer from 'components/nav/renderers/InboxNavRenderer';
import {featureFlags} from 'utils/const';

/**
 * This list shows the tabs along the top of most every page of the site,
 * each object is one tab, in the order of the list.
 *
 * Properties supported in each object
 *
 * @param name The name of the tab (lowercase is fine, CSS takes care of the capitalizing)
 * @param url The URL that we will go to if the tab is clicked
 * @param otherActiveUrls Any other URLs that should cause this tab to be shown as "active"
 * @param roles Show if the user is in one of these roles
 * @param flags Show if user has anyone of these flags
 * @param advanced A function taking (the Navigation state, user) as arguments
 * and returns a boolean. If true, show the tab
 *
 * All the show-if properties are AND-ed together, so all need to be satisfied
 */
export default List([
  {
    name: 'Home',
    url: '/home',
    flags: [featureFlags.newCoachHomepage],
    renderer: DefaultNavRenderer,
  },
  {
    name: 'Coaching',
    url: '/',
    otherActiveUrls: ['/stats', '/metrics/profile', '/dashv2'],
    onlyActiveOnIndex: true,
    renderer: DefaultNavRenderer,
  },
  {
    name: 'Calls',
    url: '/calls',
    otherActiveUrls: ['/call'],
    renderer: DefaultNavRenderer,
  },
  {
    name: 'Inbox',
    url: '/inbox',
    otherActiveUrls: ['/fullscreen'],
    renderer: InboxNavRenderer,
  },
  {
    name: 'Library',
    url: '/library',
    renderer: DefaultNavRenderer,
  },
  {
    name: 'Settings',
    url: '/admin',
    renderer: DefaultNavRenderer,
  },
]);
